export enum IconButtonVariant {
  PRIMARY = 0,
  SECONDARY = 1
}

export const DEFAULT_ICON_BUTTON_STYLES = [
  'flex',
  'flex-row',
  'items-center',
  'transition-all',
  'duration-300'
].join(' ');

export const ICON_BUTTON_STYLES = {
  [IconButtonVariant.PRIMARY]: [
    'border',
    'border-primary-blue',
    'bg-primary-white',
    'hover:shadow-primary',
    'rounded-[5px]',
    'md:rounded-[10px]',
    'justify-center',
    'w-[30px]',
    'h-[30px]',
    'md:w-10',
    'md:h-10'
  ].join(' '),
  [IconButtonVariant.SECONDARY]: ['w-6', 'h-6'].join(' ')
};

export const DISABLED_ICON_BUTTON_STYLE = [
  'cursor-auto',
  '!hover:shadow-none',
  '!shadow-none',
  'border-secondary-steel-blue'
].join(' ');
